module.exports = __webpack_public_path__ + "img/bkash.b3d67499.png";